"use strict"
exports.__esModule = true;
exports.AnsibleTowerIconConfig = {
  name: 'AnsibleTowerIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M512,0 C229.26,0 0,229.26 0,512 C0,794.74 229.26,1024 512,1024 C794.74,1024 1024,794.74 1024,512 C1024,229.26 794.74,0 512,0 Z M759.09,730.29 C759.09,751.77 741.71,766.86 721.83,766.86 C711.54,766.86 704,762.97 693.49,754.29 L429,541 L340.57,762.74 L264.23,762.74 L487.77,224.74 C493.49,210.79 506.06,203.25 520.23,203.25 C534.4,203.25 546.06,210.56 551.77,224.74 L755.89,715.2 C758.4,721.14 759.31,726.63 759.09,730.29 Z M520.69,312.69 L653.26,640 L453.26,482.51 L520.69,312.69 Z',
  yOffset: 0,
  xOffset: 0,
};
exports.AnsibleTowerIcon = require('../createIcon').createIcon(exports.AnsibleTowerIconConfig);
exports["default"] = exports.AnsibleTowerIcon;